import React from "react";
import { connect } from "react-redux";

import Layout from "../components/Layout";
import HeaderForm from "../components/HeaderForm/HeaderForm";

import { votreLiasseFiscale } from "../shared/staticTexts";

class DossierVotreLiasseFiscale extends React.Component {
  constructor(props) {
    super(props);
    if (props.dossier === null) {
      props.history.push("/dossier");
    }
    this.state = {};
  }

  render() {
    let annee = "";
    if (this.props.dossier !== null) {
      annee = this.props.dossier.annee;
    }

    return (
      <Layout>
        <HeaderForm step="4" />
        <br />
        <br />
        <br />
        <h1 className="text-center">
          {votreLiasseFiscale.title1}
          <br />
          {votreLiasseFiscale.title2.replace("{annee}", annee)}
        </h1>
        <br />
        <br />
        <br />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dossier: state.dossiers.dossier,
    isFetching: state.dossiers.fetching,
    error: state.dossiers.error,
    errorMessage: state.dossiers.errorMessage,
  };
};

export default connect(mapStateToProps, null)(DossierVotreLiasseFiscale);
